import { createContext, useCallback, useContext, useRef, useState } from "react";
import { PropsWithChildren, Ref } from "react";
import VGamepadInputProvider from "../components/VGamepad/VGamepadInputProvider";
import React from "react";

export const VGamepadContext = createContext<{
  vGamepadVisible: boolean;
  setVGamepadVisible: (b: boolean) => void;
  miniVGamepadVisible: boolean;
  setMiniVGamepadVisible: (b: boolean) => void;
  showHideVGamepadMenu: () => void;
  showMiniVGamepadTimeout?: Ref<NodeJS.Timeout | undefined>;
  inputProvider?: VGamepadInputProvider;
  setInputProvider: (v: VGamepadInputProvider) => void;
}>({
  vGamepadVisible: false,
  setVGamepadVisible: () => {
    console.warn("nop");
  },
  miniVGamepadVisible: false,
  setMiniVGamepadVisible: () => {
    console.warn("nop");
  },
  showHideVGamepadMenu: () => {
    console.warn("nop");
  },
  showMiniVGamepadTimeout: undefined,
  setInputProvider: () => {
    console.warn("nop");
  },
});

export const VGamepadContextProvider = ({ children }: PropsWithChildren<unknown>) => {
  const [vGamepadVisible, setVGamepadVisible] = useState(
    document.documentElement.clientWidth > document.documentElement.clientHeight,
  );
  const [miniVGamepadVisible, setMiniVGamepadVisible] = useState(
    document.documentElement.clientWidth < document.documentElement.clientHeight,
  );

  const showMiniVGamepadTimeout = useRef<NodeJS.Timeout>();
  const showHideVGamepadMenu = useCallback(() => {
    setMiniVGamepadVisible(true);
    if (showMiniVGamepadTimeout.current) {
      clearTimeout(showMiniVGamepadTimeout.current);
    }
    showMiniVGamepadTimeout.current = setTimeout(() => {
      setMiniVGamepadVisible(false);
    }, 5000);
    return () => {
      clearTimeout(showMiniVGamepadTimeout.current);
    };
  }, []);

  const [inputProvider, setInputProvider] = useState<VGamepadInputProvider>();
  return (
    <VGamepadContext.Provider
      value={{
        vGamepadVisible,
        setVGamepadVisible,
        miniVGamepadVisible,
        setMiniVGamepadVisible,
        showHideVGamepadMenu,
        showMiniVGamepadTimeout,
        inputProvider,
        setInputProvider,
      }}
    >
      {children}
    </VGamepadContext.Provider>
  );
};

export const useVGamepadContext = () => useContext(VGamepadContext);
